<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">

              <!-- Hospitalisation -->
              <div class="section-card">
                <div class="section-title">Hospitalisation</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Honoraires OPTAM" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="hospitalisationHonorairesOptam" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Honoraires non-OPTAM" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="hospitalisationHonorairesNonOptam" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-column label="Chambre particulière" [derrors]="derrors" [suffix]="'€'">
                      <input formControlName="hospitalisationChambreParticuliere" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Prime maternité" [derrors]="derrors">
                      <input formControlName="hospitalisationPrimeMaternite" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Optique -->
              <div class="section-card">
                <div class="section-title">Optique</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Lunettes" [derrors]="derrors" [suffix]="'€/an'">
                      <input formControlName="optiqueLunettes" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Lentilles" [derrors]="derrors" [suffix]="'€/an'">
                      <input formControlName="optiqueLentilles" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
                <div class="row mt-1">
                  <div class="col-md-6">
                    <pr-input-column label="Plafond optique" [derrors]="derrors" [suffix]="'€/an'">
                      <input formControlName="optiquePlafond" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Chirurgie laser" [derrors]="derrors" [suffix]="'€'">
                      <input formControlName="optiqueChirurgieLaser" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Dentaire -->
              <div class="section-card">
                <div class="section-title">Dentaire</div>
                <div class="row">
                  <div class="col-md-4">
                    <pr-input-column label="Prothèse" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="dentaireProthese" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-4">
                    <pr-input-column label="Orthodontie adulte" [derrors]="derrors">
                      <input formControlName="dentaireOrthodontieAdulte" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-4">
                    <pr-input-column label="Orthodontie enfant" [derrors]="derrors">
                      <input formControlName="dentaireOrthodontieEnfant" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Pharmacie -->
              <div class="section-card">
                <div class="section-title">Pharmacie</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Prise en charge" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="pharmaciePriseEnCharge" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Médecines douces -->
              <div class="section-card">
                <div class="section-title">Médecines douces</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Médecines douces" [derrors]="derrors">
                      <input formControlName="medecinesDouces" type="text" placeholder="" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Consultations -->
              <div class="section-card">
                <div class="section-title">Consultations</div>
                <div class="row">
                  <div class="col-md-6">
                    <pr-input-column label="Optam CAS" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="consultationsOptamCas" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                  <div class="col-md-6">
                    <pr-input-column label="Non-Optam non-CAS" [derrors]="derrors" [suffix]="'%'">
                      <input formControlName="consultationsNonOptamNonCas" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Cotisations -->
              <div class="section-card">
                <div class="section-title">Cotisations</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="Montant cotisation" [derrors]="derrors" [suffix]="'€'">
                      <input formControlName="cotisationsMontant" type="text" placeholder="0" />
                    </pr-input-column>
                  </div>
                </div>
              </div>

              <!-- Commentaire -->
              <div class="section-card">
                <div class="section-title">Commentaire</div>
                <div class="row">
                  <div class="col-md-12">
                    <pr-input-column label="" [derrors]="derrors" [isDefault]="false">
                      <textarea class="full-w" type="text" formControlName="commentaire" rows="3" placeholder="Commencez à écrire"></textarea>
                    </pr-input-column>
                  </div>
                </div>
              </div>

            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
